/* ==========================================================================
   Haru+ LP — JavaScript
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Scroll-reveal animation ---------- */
  function initObserver() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.anim:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });
  }
  initObserver();

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('haruplus-faq-q')) {
      var item = e.target.parentElement;
      item.parentElement.querySelectorAll('.haruplus-faq-item').forEach(function (x) {
        if (x !== item) x.classList.remove('open');
      });
      item.classList.toggle('open');
    }
  });
})();
